import { connectedStore } from '../../store';
import selectors from '../selectors';

const getBusinessCategory = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getBusinessCategory(state);
};

export default getBusinessCategory;
